import { formatUserFacingError } from '@/lib/errors'
import { useState } from 'react'
import { mailingListService } from '../services/mailingList.service'

type SignupStatus = 'idle' | 'loading' | 'success' | 'error'

export function useNewsletterSignup() {
  const [status, setStatus] = useState<SignupStatus>('idle')
  const [errorMessage, setErrorMessage] = useState<string | null>(null)

  async function signup(email: string, firstName: string, lastName: string): Promise<void> {
    setStatus('loading')
    setErrorMessage(null)
    try {
      await mailingListService.subscribe(email, firstName, lastName)
      setStatus('success')
    } catch (err) {
      setStatus('error')
      setErrorMessage(formatUserFacingError(err, 'Something went wrong. Please try again.'))
    }
  }

  return { signup, status, errorMessage }
}
